module.exports = __webpack_public_path__ + "img/loop.b423d0aa.svg";